import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import ListFinancial from './ListFinancial'

import EditFinancial from './EditFinancial'
import NewFinancial from './NewFinancial'

const SpecialistFinancialRoutes = () => {

  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListFinancial /></PrivateRoute7>} />
        <Route path="edit-financial" element={<PrivateRoute7><EditFinancial /></PrivateRoute7>} />
        <Route path="new-financial" element={<PrivateRoute7><NewFinancial /></PrivateRoute7>} />
    </Routes>
  )
}

export default SpecialistFinancialRoutes